var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureIotSuite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a24",
    x1: 9.13,
    y1: 18.81,
    x2: 8.85,
    y2: -8.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#22a5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#29bade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2ec9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#31d1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#32d4f5"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4,
    cy: 8.44,
    r: 1.97,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7,
    cy: 14.3,
    r: 1.55,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.57,
    cy: 13.24,
    r: 1.33,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.61,
    cy: 3.11,
    r: 1.65,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19,
    cy: 9.19,
    r: 1.33,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M15.06 13.99l-3.33-5.83-.33.19.27-.2L7.9 2.79l-.69.5 3.34 4.75-7.4.61.07.86 7.33-.61-2.43 4.04.73.44 2.5-4.16 2.97 5.19.74-.42z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#949494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.53 1.23A.73.73 0 0016.8.5H13a.36.36 0 00-.36.36v1.41a.36.36 0 00.36.36h2.35v2.3a.38.38 0 00.37.37h1.4a.38.38 0 00.37-.37v-3.7zM5 15.37H2.61v-2.3a.38.38 0 00-.37-.37H.84a.38.38 0 00-.37.37v3.7a.73.73 0 00.73.72H5a.36.36 0 00.36-.36v-1.4a.36.36 0 00-.36-.36z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 6.49a2 2 0 11-2 1.95 2 2 0 012-1.95zM6 3.11a1.66 1.66 0 101.62-1.65A1.65 1.65 0 006 3.11zM1.86 9.18a1.33 1.33 0 101.33-1.33 1.33 1.33 0 00-1.33 1.33zm5.38 4.05a1.34 1.34 0 101.34-1.33 1.33 1.33 0 00-1.34 1.33zm5.92 1.07a1.55 1.55 0 101.55-1.54 1.53 1.53 0 00-1.55 1.54z",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIotSuite);
export default __webpack_public_path__ + "static/media/azure-iotSuite.7273485fab27398cb435f15021c21fb9.svg";
export { ForwardRef as ReactComponent };